import $http from './http'
import config from './config'

export default {
  name: 'base',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getCountrys(id) {
    return $http.get(this.getUrl(`/CountryInfo/Countrys/${id}`));
  },
  getCitys(countryID) {
    return $http.get(this.getUrl(`/TourServers/GetCityInfo/${countryID}`));
  },
  getTrainStation(data) {
    return $http.post(this.getUrl(`/TourServers/LoadCityInfo`), data);
  },
  getdistinct(data) {
    return $http.post(this.getUrl('/DistrictInfo/GetDist'), data);
  },
  getZoneList(data) {
    return $http.post(this.getUrl(`/ZoneInfo/List`), data).then(function (json) {
      if (json.data.isSucc) {
        for (let i = 0; i < json.data.result.entities.length; i++) {
          let result = json.data.result.entities[i]
          let keywords = result.CityName + ',' + result.CountryName + ',' + result.ZoneName + ',' + result.ZoneCode + ',' + result.ZoneShortSpell + ',' + result.ZoneSpell
          result.keywords = keywords;
          result.label = result.ZoneName;
        }
      }
      return json
    });
  },
  getAirwayInfoList(data) {
    return $http.post(this.getUrl('/AirwayInfo/List'), data);
  },
  gettripcomVersion() {
    let reg = /^app./g;
    let hostname = window.location.hostname;
    if (!reg.test(hostname) || hostname == "app.ecs.net") {
      hostname = 'app.lchtrip.com';
    }
    return $http.get(this.getUrl(`/static/${hostname.replace(/\./g,'')}/version.json`).replace('/api/base', ''), );
  }
}



// WEBPACK FOOTER //
// ./src/apis/baseApis.js